import { config, handleResponse } from '../../_helpers';

export const companyPolicyServices = {
    getCompanyPoliciesByCode,
    getAllCompanyPolicies,
    getCompanyPolicies,
    createCompanyPolicy,
    updateCompanyPolicy,
    getCompanyPolicyById,
    deleteCompanyPolicies,
    activation,
    searchCompanyPolicies,
    getCompanyPolicyReadListByCode,
};
function getCompanyPoliciesByCode() {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/CompanyPolicies/getByList`, requestOptions).then(handleResponse);
}

function getAllCompanyPolicies() {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/CompanyPolicies`, requestOptions).then(handleResponse);
}
function getCompanyPolicies(skip, take) {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/CompanyPolicies/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
}
function createCompanyPolicy(CompanyPolicy, userProfile) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            code: CompanyPolicy.code,
            defaultValueDecimal: CompanyPolicy.defaultValueDecimal,
            dateEffective: CompanyPolicy.dateEffective,
            inputtedString: CompanyPolicy.inputtedString,
            userCreated: userProfile.userId
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/CompanyPolicies`, requestOptions).then(handleResponse);
}
function updateCompanyPolicy(CompanyPolicy, userProfile) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify({
            code: CompanyPolicy.code,
            defaultValueDecimal: CompanyPolicy.defaultValueDecimal,
            dateEffective: CompanyPolicy.dateEffective,
            inputtedString: CompanyPolicy.inputtedString,
            userModified: userProfile.userId
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/CompanyPolicies/update/${CompanyPolicy.id}`, requestOptions).then(handleResponse);
}
function getCompanyPolicyById(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/CompanyPolicies/get/${id}`, requestOptions).then(handleResponse);
}
function getCompanyPolicyReadListByCode(code) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/CompanyPolicies/ReadListByCode/${code}`, requestOptions).then(handleResponse);
}
function deleteCompanyPolicies(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/CompanyPolicies/delete`, requestOptions).then(handleResponse);
}
function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };

    return fetch(`${config.apiUrl}/CompanyPolicies/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}
function searchCompanyPolicies(take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/CompanyPolicies/load?filter=${filter}&search=${search}&take=${take}`, requestOptions).then(handleResponse);
}